import React, { memo } from 'react'
import { Grid } from '@material-ui/core'
import { BackgroundPositionEnum, Image } from './Image'
import { useStyles } from './Card.styles'
import { LightText } from 'components/ui/Typography/LightText'
import { Paragraph } from 'components/ui/Typography/Paragraph'
import { Title } from 'components/ui/Typography/Title'
import { Badge } from './Badge'
import { ITag } from 'shared/types'
import clsx from 'clsx'

interface ICardProps {
  imageUrl: any
  imageSize?: 'stretch' | 'preserve-ratio' | 'crop'
  lightText?: string
  title?: string
  titleMaxLength?: number
  description?: string
  descriptionMaxLength?: number
  imageRatio?: number
  tags?: ITag[]
  isTitleCentered?: boolean
  backgroundPosition?: BackgroundPositionEnum
  isDraft?: boolean
}

export const Card = memo(
  ({
    imageUrl,
    imageSize = 'preserve-ratio',
    lightText,
    title,
    titleMaxLength,
    description,
    descriptionMaxLength,
    imageRatio,
    tags,
    isTitleCentered = false,
    backgroundPosition,
    isDraft
  }: ICardProps) => {
    const classes = useStyles()

    return (
      <article className={clsx(isTitleCentered && classes.article)}>
        <Grid item className={classes.image}>
          <Image
            backgroundUrl={imageUrl}
            backgroundSize={imageSize}
            backgroundPosition={backgroundPosition}
            ratio={imageRatio}
          />
        </Grid>

        {title && (
          <span>
            <Title className={classes.title} maxLength={titleMaxLength}>
              {title}
            </Title>
          </span>
        )}
        <Grid container alignItems="center" spacing={tags && 1} className={classes.subtitle}>
          {lightText && (
            <Grid item>
              <LightText>{lightText}</LightText>
            </Grid>
          )}
          {tags &&
            tags.map((tag: ITag, index: number) => (
              <Grid item key={index}>
                <Badge title={tag.name} />
              </Grid>
            ))}

          {description && (
            <Paragraph className={classes.paragraph} maxLength={descriptionMaxLength}>
              {description}
            </Paragraph>
          )}
        </Grid>
        {isDraft && <span className={classes.draft}>DRAFT</span>}
      </article>
    )
  }
)
